var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgEnterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8L18 8.5C18.2761 8.5 18.5 8.27614 18.5 8L18 8ZM0.646444 7.64645C0.451183 7.84171 0.451183 8.15829 0.646444 8.35355L3.82843 11.5355C4.02369 11.7308 4.34027 11.7308 4.53553 11.5355C4.73079 11.3403 4.73079 11.0237 4.53553 10.8284L1.70711 8L4.53553 5.17157C4.73079 4.97631 4.73079 4.65973 4.53553 4.46447C4.34027 4.26921 4.02369 4.26921 3.82843 4.46447L0.646444 7.64645ZM18.5 0.5C18.5 0.223857 18.2761 -2.41411e-08 18 0C17.7239 2.41411e-08 17.5 0.223857 17.5 0.5L18.5 0.5ZM18 7.5L9.5 7.5L9.5 8.5L18 8.5L18 7.5ZM9.5 7.5L0.999998 7.5L0.999998 8.5L9.5 8.5L9.5 7.5ZM18.5 8L18.5 0.5L17.5 0.5L17.5 8L18.5 8Z",
    fill: "#4091F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterIcon);
export default __webpack_public_path__ + "static/media/enter-icon.a897fc258bfb4cc12255b0ce39ff900c.svg";
export { ForwardRef as ReactComponent };